import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/mysite/app/layouts/default.vue").then(m => m.default || m)),
  seo: defineAsyncComponent(() => import("/var/www/mysite/app/layouts/seo.vue").then(m => m.default || m))
}